export enum SortDirection {
  ascending = 'ascending',
  descending = 'descending',
}
